export const OMDB_CONFIG = {
  BASE_URL: 'https://www.omdbapi.com',
  API_KEY: process.env.REACT_APP_OMDB_API_KEY || '',
};
